import { ContractTerminationDestination } from '../../../../common/types'
import { useTerminationDestinationToLabel } from './useTerminationDestinationToLabel'

export const useContractTerminationDestinations = () => {
  const { terminationDestinationToLabel } = useTerminationDestinationToLabel()

  const contractTerminationDestinations = [
    ContractTerminationDestination.BUYING_PROPERTY,
    ContractTerminationDestination.MOVE_TO_ANOTHER_APARTMENT_OF_SAME_OWNER,
    ContractTerminationDestination.MOVE_TO_ANOTHER_RENTAL,
    ContractTerminationDestination.MOVE_TO_RIGHT_OF_OCCUPANCY_OF_SAME_OWNER,
    ContractTerminationDestination.MOVE_TO_RIGHT_OF_OCCUPANCY_OF_ANOTHER_OPERATOR,
    ContractTerminationDestination.MOVE_TO_RIGHT_OF_OCCUPANCY,
    ContractTerminationDestination.MOVE_TO_CARE_HOME_OR_HOSPITAL,
    ContractTerminationDestination.OTHER,
  ].map((destination) => ({
    id: destination,
    label: terminationDestinationToLabel(destination),
  }))

  return { contractTerminationDestinations }
}
